
import { defineComponent, onMounted, ref } from "vue";
import AddCustomerModal from "@/components/modals/forms/AddAdmissionsApplication.vue";
import ProfileDetailInfor from "@/components/customers/ProfileDetailInfor.vue";
import WidgetComment from "@/components/widgets/lists/WidgetComment.vue";
import WidgetAssign from "@/components/widgets/lists/WidgetAssign.vue";
import WidgetAssignHistory from "@/components/widgets/lists/WidgetAssignHistory.vue";
import ModalDeleteAndReason from "@/components/modals/wizards/ModalDeleteAndReason.vue";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import axios from "@/axios-instance"
import moment from "moment"
import Permission from "@/core/config/Permission";
import { saveAs } from 'file-saver';
import { useRoute, useRouter } from "vue-router";
import { emitter } from "@/main";


interface Form {
  status: string;
  fullName: string;
  gender: string;
  dateOfBirth: string;
  birthPlace: string;
  phone: string;
  idCard: string;
  email: string;
  contactAddress: string;
  contactProvinceId: string;
  contactDistrictId: string;
  contactWardId: string;
  prProvinceId: string;
  prDistrictId: string;
  prWardId: string;
  prAddress: string;
  class10ProvinceId: string;
  class10DistrictId: string;
  class10SchoolId: string;

  class11ProvinceId: string;
  class11DistrictId: string;
  class11SchoolId: string;

  class12ProvinceId: string;
  class12DistrictId: string;
  class12SchoolId: string;
  graduatedYear: string;
  priorityObject: string;
  priorityArea: string;
  priorityScore: number;
  highschoolGraduation: string;
  verifiedDate: string;
  orderNumber: string;
}
interface formRegister {
  source: string;
  createdAt: string;
  phase: string;
}
export default defineComponent({
  name: "customer-details",
  components: {
    AddCustomerModal,
    ProfileDetailInfor,
    WidgetComment,
    WidgetAssign,
    WidgetAssignHistory,
    ModalDeleteAndReason,
  },
  data() {
      return {
          idStudent: '',
          idAdReg: '',
          isChangeStatus: false,
          isChangeSource: false,
          profileCode: '',
          arrPhase: [] as any,
          isChangeStatusGraduated: false,
          isHighschool: false,
          additionalPhase: false,
          submithighschoolGraduation: "",
          statusRecord: "",
          rejectReason: "",
          _origStatus: "",
          _origGraduation: "",
          _origSource: null as any,
          _origAdditionalPhase: false,
      }
  },
  computed: {
    // linkMenu() {
    //   let fullPath = this.$route.fullPath.split('/')
    //   if(fullPath.length>1) {
    //     return fullPath[1]
    //   }
    // }
  },
  methods: {
    checkHighschoolGraduation(isCheck) {
      this.isHighschool = isCheck
    },
    // Ngày quyết định trúng tuyển (BE trả ISO) — chỉ để hiển thị
    formatDate(d) {
      return d ? moment(d).format('DD/MM/YYYY') : ''
    },
    callModalDelete() {
      (this.$refs.callFunctionModal as any)?.showModal()
    },
    // Xóa mềm hồ sơ (PUT update/ids, isDelete=true + lý do) rồi quay về CHI TIẾT ỨNG VIÊN,
    // tab "Hồ sơ đăng ký xét" (#tab3) — chỗ nhìn thấy ngay hồ sơ vừa xóa đã biến mất; về danh sách
    // hồ sơ thì mất luôn ngữ cảnh ứng viên đang xử lý.
    // BE còn chặn: hồ sơ đã xác thực / đã trúng tuyển -> báo lỗi ở errorMessage.
    async isDeleteFunction(reason = undefined) {
      const data = { ids: [this.idAdReg], isDelete: true, reason }
      await axios.put(`/admission/register/update/ids`, data)
        .then(() => {
          const _idStudent = this.idStudent || this.dataCustomer?.id
          ;(this as any).router.push(_idStudent ? `/danhsachungvien/${_idStudent}#tab3` : '/danhsachhoso')
        })
        .catch(({ response }) => {
          Swal.fire({
            text: response?.data?.errorMessage || response?.data?.message || 'Không thể xóa hồ sơ, vui lòng thử lại.',
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Trở lại",
            customClass: { confirmButton: "btn btn-primary" },
          })
        })
    },
    // Vào chế độ sửa "Trạng thái hồ sơ" — lưu giá trị gốc để Hủy khôi phục.
    editStatus() {
      this._origStatus = this.statusRecord
      this.isChangeStatus = true
    },
    cancelStatus() {
      this.statusRecord = this._origStatus
      this.rejectReason = ''
      this.isChangeStatus = false
    },
    //Toggle Kích hoạt hồ sơ (cạnh subheader Thông tin xét tuyển): confirm rồi LƯU NGAY — tách khỏi luồng Thay đổi/Lưu của Xác thực
    async toggleActiveConfirm() {
      const reg = this.dataAdmissionRegister?.adRegister
      if (!reg || this.isAppraised) return
      const next = !reg.isActive
      const result = await Swal.fire({
        title: next ? 'Bật kích hoạt hồ sơ' : 'Tắt kích hoạt hồ sơ',
        html: next
          ? `Bật kích hoạt hồ sơ <b>${reg.profileCode}</b>?`
          : `Tắt kích hoạt hồ sơ <b>${reg.profileCode}</b>? Hồ sơ tắt kích hoạt sẽ hiển thị mờ ở Danh sách hồ sơ.`,
        icon: 'question', showCancelButton: true, buttonsStyling: false,
        confirmButtonText: next ? 'Bật kích hoạt' : 'Tắt kích hoạt', cancelButtonText: 'Hủy',
        customClass: { confirmButton: 'btn btn-primary order-2', cancelButton: 'btn btn-light order-1' },
      })
      if (!result.isConfirmed) return
      try {
        await axios.put(`/admission/register/${reg.id}`, { isActive: next })
        reg.isActive = next
        Swal.fire({ text: next ? 'Đã bật kích hoạt hồ sơ.' : 'Đã tắt kích hoạt hồ sơ.', icon: 'success', timer: 1500, timerProgressBar: true, buttonsStyling: false, confirmButtonText: 'Đóng', customClass: { confirmButton: 'btn btn-primary' } })
      } catch (e) {
        Swal.fire({ text: 'Không cập nhật được trạng thái kích hoạt.', icon: 'error', buttonsStyling: false, confirmButtonText: 'Đã hiểu', customClass: { confirmButton: 'btn btn-primary' } })
      }
    },
    // Lưu "Xác thực hồ sơ" (Kích hoạt đã tách thành toggle confirm riêng). Đẩy SF + ghi timeline CHỈ khi trạng thái thực sự đổi.
    async saveStatus() {
      const reg = this.dataAdmissionRegister?.adRegister
      if(!reg) return
      const statusChanged = this.statusRecord !== this._origStatus
      if(!statusChanged) { this.isChangeStatus = false; return }

      // Kiểm tra chỉ khi ĐỔI trạng thái
      if(statusChanged) {
        if(this.statusRecord == 'verified' && !this.dataCustomer.highschoolGraduation) {
          this.isHighschool = true
          Swal.fire({ text: "Vui lòng kiểm tra lại điều kiện tốt nghiệp THPT của ứng viên này!", icon: "warning", buttonsStyling: false, confirmButtonText: "Trở lại", customClass: { confirmButton: "btn btn-primary" } })
          return
        }
        if(this.statusRecord == 'verified' && reg.idAdMethod != 9
           && Array.isArray(this.dataAdmissionRegister.adMajors)
           && !this.dataAdmissionRegister.adMajors.some((m) => m && m.major)) {
          Swal.fire({ text: 'Hồ sơ chưa chọn ngành (hoặc ngành đã bị xoá) nên không thể chuyển sang "Đã xác thực". Vui lòng chọn lại ngành đăng ký trước.', icon: 'warning', buttonsStyling: false, confirmButtonText: 'Đã hiểu', customClass: { confirmButton: 'btn btn-primary' } })
          return
        }
        if(this.statusRecord == 'rejected' && !this.rejectReason) {
          Swal.fire({ text: "Vui lòng điền lý do hồ sơ không hợp lệ!", icon: "warning", buttonsStyling: false, confirmButtonText: "Trở lại", customClass: { confirmButton: "btn btn-primary" } })
          return
        }
      }
      const isSfPush = statusChanged && (this.statusRecord == 'verified' || this.statusRecord == 'reviewing')
      if(isSfPush) {
        const result = await Swal.fire({
          title: 'Xác nhận đẩy Salesforce',
          html: this.statusRecord == 'verified'
            ? 'Chuyển sang <b>Đã xác thực</b> sẽ <b>đẩy hồ sơ lên Salesforce</b> (convert Lead → Opportunity, không hoàn tác phía SF). Tiếp tục?'
            : 'Chuyển sang <b>Đang xem xét</b> sẽ <b>tạo / đồng bộ Lead trên Salesforce</b>. Tiếp tục?',
          icon: 'warning', showCancelButton: true, buttonsStyling: false,
          confirmButtonText: 'Đồng ý, đẩy SF', cancelButtonText: 'Hủy',
          customClass: { confirmButton: 'btn btn-primary', cancelButton: 'btn btn-light me-3' },
        })
        if(!result.isConfirmed) return
      }
      // Lưu Xác thực — đẩy SF + ghi timeline
      if(statusChanged) {
        try {
          const { data } = await axios.put(`/admission/register/${reg.id}`, { status: this.statusRecord })
          reg.status = this.statusRecord
          const sfErrors = (data && data.errors) || []
          try {
            const _u = JSON.parse(window.localStorage.getItem('user') || 'null')
            const _idStudent = this.dataCustomer.id || this.idStudent
            const _label = (this.statusTag && this.statusTag[this.statusRecord] && this.statusTag[this.statusRecord].label) || this.statusRecord
            let _cmt = `Cập nhật trạng thái hồ sơ ${reg.profileCode}: ${_label}`
            if(this.statusRecord == 'rejected' && this.rejectReason) _cmt += `. Lý do: ${this.rejectReason}`
            const _res = await axios.post('/admission/comment', { idUser: _u?.id, idStudent: _idStudent, comment: _cmt })
            emitter.emit('addComment', _res.data)
          } catch (e) { /* ghi timeline lỗi không chặn */ }
          if(isSfPush && sfErrors.length) {
            Swal.fire({ title: 'Đã lưu trạng thái — nhưng ĐẨY SALESFORCE LỖI', html: `Cập nhật trạng thái <b>thành công</b>, nhưng <b>đẩy Salesforce thất bại</b>:<br>• ${sfErrors.join('<br>• ')}<br><br>Có thể bấm "Đồng bộ Salesforce" để thử lại.`, icon: 'warning', buttonsStyling: false, confirmButtonText: 'Đã hiểu', customClass: { confirmButton: 'btn btn-primary' } })
          } else {
            Swal.fire({ text: isSfPush ? 'Cập nhật trạng thái & đẩy Salesforce thành công.' : 'Cập nhật thành công.', icon: 'success', timer: 2000, timerProgressBar: true, buttonsStyling: false, confirmButtonText: 'Đóng', customClass: { confirmButton: 'btn btn-primary' } })
          }
        } catch (err: any) {
          Swal.fire({ title: 'Cập nhật trạng thái thất bại', text: (err && err.response && err.response.data && (err.response.data.message || err.response.data.errorMessage)) || 'Có lỗi xảy ra, vui lòng thử lại.', icon: 'error', buttonsStyling: false, confirmButtonText: 'Đã hiểu', customClass: { confirmButton: 'btn btn-primary' } })
          return
        }
      } else {
        Swal.fire({ text: 'Cập nhật thành công.', icon: 'success', timer: 1500, timerProgressBar: true, buttonsStyling: false, confirmButtonText: 'Đóng', customClass: { confirmButton: 'btn btn-primary' } })
      }
      this.rejectReason = ''
      this._origStatus = this.statusRecord
      this.isChangeStatus = false
    },
    cancelGraduated() {
      this.dataCustomer.highschoolGraduation = this._origGraduation
      this.isChangeStatusGraduated = false
      this.isHighschool = false
    },
    async changeStatusGraduated() {
      if(!this.isChangeStatusGraduated) {
        this._origGraduation = this.dataCustomer.highschoolGraduation
        this.isChangeStatusGraduated = true
        // Select giờ chỉ render Ở CHẾ ĐỘ SỬA -> ref chưa tồn tại ngay, phải đợi 1 nhịp mới focus được
        this.$nextTick(() => { (this as any).statusGraduated?.focus() })
      }
      else {
        //Số hiệu bằng nhập ở tab Học tập (đi cùng Năm tốt nghiệp) — card này chỉ đổi điều kiện tốt nghiệp
        let data = {
          highschoolGraduation: this.dataCustomer.highschoolGraduation,
          // verifiedDate: this.dataCustomer.highschoolGraduation !='not_graduated'?this.dataCustomer.verifiedDate:undefined
        }
        await axios.put(`/admission/student/${this.idStudent}`,data)
        .then(async ( {data} ) => {
          this.isChangeStatusGraduated = false
          this.isHighschool = false
          this.submithighschoolGraduation = this.dataCustomer.highschoolGraduation
          // Ghi nhận vào timeline ghi chú + cập nhật NGAY (không load trang) qua emitter "addComment".
          try {
            const _gLabels = { not_graduated: 'Chưa tốt nghiệp THPT', temp_graduated: 'Giấy chứng nhận TNTT', graduated: 'Đã tốt nghiệp THPT' }
            const _u = JSON.parse(window.localStorage.getItem('user') || 'null')
            const _idStudent = this.dataCustomer.id || this.idStudent
            const _cmt = `Cập nhật điều kiện tốt nghiệp THPT: ${_gLabels[this.dataCustomer.highschoolGraduation] || this.dataCustomer.highschoolGraduation}`
            const _res = await axios.post('/admission/comment', { idUser: _u?.id, idStudent: _idStudent, comment: _cmt })
            emitter.emit('addComment', _res.data)
          } catch (e) { /* ghi timeline lỗi không chặn luồng lưu graduation */ }
        })
        .catch(({ response }) => {
          console.log('err',response)
        });
      }
    },
    async downloadAdmission(id) {
      await axios.get(`/admission/register/download/${id}`,
        {responseType: 'arraybuffer', }) //arraybuffer, blob
        .then((response) => {
          const blob = new Blob([response.data], {
            type: 'application/octet-stream'
          })
          const url = URL.createObjectURL(blob)
          let cd = response.headers['content-disposition'].split('"')
          const fileName = cd.length > 1 ? cd[1] : 'ho-so.zip'
          saveAs(url, fileName)
        }).catch(err=> {
          console.log('err',err)
        })
    },
    yesNoEmail(id) {
      Swal.fire({
        text: `Bạn có muốn gửi mail cho sinh viên này không?`,
        icon: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Đồng ý",
        cancelButtonText: "Trở lại",
        customClass: {
          confirmButton: "btn btn-primary order-2",
          cancelButton: "btn btn-light order-1",
        },
      }).then(async (result) => {
        if(result.isConfirmed) {
          this.sendMail(id)
        }
        Swal.close()
      });
    },
    async sendMail(id) {
      // Đợi kết quả thật từ BE (_process.errors) thay vì báo "thành công" ngay bằng setTimeout.
      try {
        const { data: _process } = await axios.post(`/admission/mail/send/`, { "idAdReg": id })
        const failed = _process && Array.isArray(_process.errors) && _process.errors.length > 0
        if (failed) {
          Swal.fire({
            text: "Gửi email chưa thành công — vui lòng kiểm tra lại thông tin hồ sơ rồi thử lại.",
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Đóng",
            customClass: { confirmButton: "btn btn-primary" },
          })
          return
        }
        Swal.fire({
          text: "Đã gửi email đến sinh viên thành công!",
          icon: "success",
          buttonsStyling: false,
          confirmButtonText: "Đóng",
          customClass: { confirmButton: "btn btn-primary" },
        })
        // BE đã đánh dấu sentMail + ghi timeline khi gửi OK -> cập nhật cờ tại chỗ + nạp lại timeline (không reload trang)
        if (this.dataAdmissionRegister && this.dataAdmissionRegister.adRegister) {
          this.dataAdmissionRegister.adRegister.sentMail = true
        }
        emitter.emit('reloadComment')
      } catch (e) {
        Swal.fire({
          text: "Gửi email thất bại (lỗi kết nối hoặc máy chủ). Vui lòng thử lại.",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Đóng",
          customClass: { confirmButton: "btn btn-primary" },
        })
      }
    },
    async getPdf(profileCode) {
      // Backend LUÔN render lại phiếu từ dữ liệu hiện tại (Puppeteer) -> có thể mất ~15-20s -> hiện loading.
      Swal.fire({
        html: "<div class='custom-loading'><span>Đang tạo phiếu đăng ký xét tuyển. Vui lòng chờ trong giây lát!!!</span> <span class='loader'></span></div>",
        buttonsStyling: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
      })
      await axios.get(`/admission/pdf/${profileCode}`)
      .then(( {data} ) => {
        Swal.close()
        window.open(data.path,'_blank');
      })
      .catch(({ response }) => {
        Swal.close()
        Swal.fire({
          text: response?.data?.errorMessage || "Không tạo được phiếu, vui lòng thử lại sau.",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Đã hiểu",
          customClass: { confirmButton: "btn btn-primary" },
        })
        console.log('err',response)
      });
    },
    async changeStatus(){
      if(!this.isChangeStatus) {
        this.isChangeStatus = true
        this.selectStatus?.focus()
      }
      else {
        let data = {
          status: this.dataCustomer.status
        }
        await axios.put(`/admission/student/${this.idStudent}`,data)
        .then(( {data} ) => {
          this.isChangeStatus = false
        })
        .catch(({ response }) => {
          console.log('err',response)
        });
      }
    },
    cancelSource() {
      if (this._origSource) this.dataFormRegister = { ...this._origSource }
      this.additionalPhase = this._origAdditionalPhase
      this.isChangeSource = false
    },
    async changeSource(){
      if (!this.formRef) {
        return;
      }
      this.formRef.validate(async (valid) => {
        if (valid) {
          if(!this.isChangeSource) {
          this._origSource = JSON.parse(JSON.stringify(this.dataFormRegister))
          this._origAdditionalPhase = this.additionalPhase
          this.isChangeSource = true
          return
        }
        else {
          let data = {
            "source": this.dataFormRegister.source,
            "createdAt": this.dataFormRegister.createdAt,
            "phase": this.dataFormRegister.phase,
            "isExtra":this.dataFormRegister.source !='online'?this.additionalPhase:undefined
          }
          await axios.put(`/admission/register/${this.idAdReg}`,data)
          .then(( {data} ) => {
            this.isChangeSource = false
          })
          .catch(({ response }) => {
            console.log('err',response)
          });
        }
        }
      })
    },
    async getData(id) {
      await axios.get(`/admission/register/${id}`)
      .then(( {data} ) => {
        data.adRegister.updatedAt = moment(data.adRegister.updatedAt).format('DD/MM/YYYY HH:mm')
        // Set giá trị form TRƯỚC, dataAdmissionRegister SAU CÙNG:
        // dataAdmissionRegister mở các khối v-if (Trạng thái/Thông tin xét tuyển/AddCustomerModal);
        // nếu set trước rồi mới đổ giá trị, el-select bên trong mount-rồi-unmount trong cùng nhịp
        // -> nextTick nội bộ của select đọc $el của ref null (lỗi console "reading '$el'").
        this.statusRecord = data.adRegister.status
        this.dataFormRegister = {
          "source": data.adRegister.source,
          "createdAt": data.adRegister.createdAt,
          "phase": data.adRegister.phase,
        }
        if(data.adRegister.isArchived){
          this.isAppraised = data.adRegister.isArchived
        }
        else {
          this.isAppraised = data.adRegister.isAppraised
        }

        this.idStudent = data.adRegister.idStudent
        this.profileCode = data.adRegister.profileCode
        // Liên thông (idAdMethod=9) và một số hồ sơ không trả về adDetails => tránh crash,
        // lấy id hồ sơ xét tuyển trực tiếp từ adRegister.
        this.idAdReg = (data.adDetails && data.adDetails[0] && data.adDetails[0].idAdReg) || data.adRegister.id
        this.dataAdmissionRegister = data

        this.getDataStudent(this.idStudent)
      })
      .catch(({ response }) => {
        console.log('err',response)
        // 403 = hồ sơ không thuộc phụ trách (chốt BE 2026-07) -> báo NHẸ rồi quay lại
        if (response?.status === 403) {
          Swal.fire({
            text: response?.data?.errorMessage || 'Hồ sơ này không thuộc phụ trách của bạn.',
            icon: 'info',
            timer: 2600,
            timerProgressBar: true,
            buttonsStyling: false,
            showConfirmButton: false,
          })
          window.history.back() // hybrid component không type $router (TS2551) — back bằng history API
        }
      });
    },
    async getDataStudent(id) {
      await axios.get(`/admission/student/${id}`)
      .then(( {data} ) => {
          data.updatedAt = moment(data.updatedAt).format('DD/MM/YYYY HH:mm')
          data.createdAt = moment(data.createdAt).format('DD/MM/YYYY HH:mm')
          this.dataCustomer = data
          this.submithighschoolGraduation = this.dataCustomer.highschoolGraduation
          this.prScore = data.priorityScore?data.priorityScore:0
      })
      .catch(({ response }) => {
        console.log('err',response)
      });
    },

  },
  async created() {
    await this.getData(this.route.params.id)
    await axios.get('/phase')
    .then(( {data} ) => {
      this.arrPhase = data.map(i => {return {name:'Đợt '+i.phaseNo,id:i.id}})
    })
    .catch(({ response }) => {
      console.log('err',response)
    });
    axios.get(`/setting/generalsetting?type=source`)
      .then(( {data} ) => {
        if(data.length!=0) {
          this.arrResource = data.map(i=>{return{
            value: i.code,
            label: i.name
          }})
        }
      })
      .catch(({ response }) => {
        console.log('err',response)
      });
  },
  setup() {
    const route = useRoute()
    // this.$router không có type (vue-router 4 chưa augment ComponentCustomProperties ở dự án này)
    // -> lấy router qua useRouter rồi expose, dùng this.router.push như candidateListDetail
    const router = useRouter()
    const formRef = ref();
    const isEdit = ref(true)
    const isAppraised = ref(false)
    const selectStatus = ref<null | HTMLFormElement>(null);
    const statusGraduated = ref<null | HTMLFormElement>(null);
    const prScore = ref(0)
    const arrResource = ref([
      {
        value: "online",
        label: "Trực tuyến"
      },
      {
        value: "office",
        label: "Trực tiếp"
      },
      {
        value: "postoffice",
        label: "Bưu điện"
      },
      {
        value: "email",
        label: "Email"
      },
    ])
    const rules = ref({
      createdAt: [
        {
          required: true,
          message: "Vui lòng điền trường này",
          trigger: "change",
        },
      ],
    })
    const dataFormRegister = ref<formRegister> ({
      "source": '',
      "createdAt": '',
      "phase": '',
    })
    const dataCustomer = ref<any>({
      status: "",
      fullName: "",
      gender: "",
      birthPlace: "",
      dateOfBirth: "",
      phone: "",
      idCard: "",
      email: "",
      contactAddress: "",
      contactProvinceId: "",
      contactDistrictId: "",
      contactWardId: "",
      prProvinceId: "",
      prDistrictId: "",
      prWardId: "",
      prAddress: "",
      class10ProvinceId: "",
      class10DistrictId : "",
      class10SchoolId : "",
      class11ProvinceId: "",
      class11DistrictId : "",
      class11SchoolId : "",
      class12ProvinceId: "",
      class12DistrictId : "",
      class12SchoolId : "",
      graduatedYear:"",
      priorityObject: "00",
      priorityArea: "",
      priorityScore: 0,
      highschoolGraduation:"",
      verifiedDate: "",
      orderNumber: "",
    });
    const dataAdmissionRegister = ref<any>(null)
    const statusTag =  ref({
      "new": {
        label:"Mới",
        state: "primary",
        icon: 'new',
      },
      "processing": {
        label:"Chưa hoàn tất",
        state: "warning",
        icon: '/media/icons/duotune/general/gen044.svg',
      },
      "verified": {
        label:"Đã xác thực",
        state: "success",
        icon: '/media/icons/duotune/general/gen026.svg',
      },
      "reviewing": {
        label:"Đang xem xét",
        state: "info",
      },
      "rejected": {
        label:"Không hợp lệ",
        state: "danger",
        icon: "/media/icons/duotune/arrows/arr015.svg",
      },
      "denied": {
        label:"Từ chối",
        state: "danger",
        icon: "/media/icons/duotune/arrows/arr015.svg",
      },
    })
    // Nhãn điều kiện tốt nghiệp THPT cho dòng xem (card Trạng thái hồ sơ)
    const graduationTag = ref({
      "not_graduated": { label: "Chưa tốt nghiệp", state: "danger" },
      "temp_graduated": { label: "Chứng nhận TNTT", state: "warning" },
      "graduated": { label: "Đã tốt nghiệp", state: "success" },
    })
    return {
        dataCustomer,
        prScore,
        dataAdmissionRegister,
        statusTag,
        graduationTag,
        isEdit,
        isAppraised,
        selectStatus,
        statusGraduated,
        arrResource,
        Permission,
        rules,
        formRef,
        dataFormRegister,
        route,
        router,
    };
  },
});
